/**
 * ChefYoda brand constants + host detection, shared by the non-lazy
 * shell (Login, AuthLoadingScreen) and the OrderPad layout. Split from
 * the toque component so component files export only components
 * (react-refresh rule).
 */

export const CHEFYODA_GOLD = '#b8860b';
export const CHEFYODA_GOLD_STROKE = '#C9A84C';
export const CHEFYODA_INK = '#14120e';
export const CHEFYODA_CREAM = '#faf8f3';

/** True on any ChefYoda-branded host (chefyoda-dev., chefyoda.). */
export function isChefYodaHost(): boolean {
  return typeof window !== 'undefined' && window.location.hostname.startsWith('chefyoda');
}
